import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    // 群发列表
    getMsgList: {
        url: `${customerApi}/api/mass_sending`,
        type: 'GET',
    },

    // 群发明细列表
    getMsgDetails: {
        url: `${customerApi}/api/mass_sending/{id}/details`,
        type: 'GET',
    },

    // 创建群发
    createMsg: {
        url: `${customerApi}/api/mass_sending`,
        type: 'POST',
    },

    // 群发摘要
    getMsgSummary: {
        url: `${customerApi}/api/mass_sending/{id}/summary`,
        type: 'GET',
    },

    // 获取客户管理的客户
    getCustomers: {
        url: `${customerApi}/api/customers/search`,
        type: 'POST',
    },

    // 获取重发详情
    getRepeatDetails: {
        url: `${customerApi}/api/mass_sending/{id}/replicator`,
        type: 'GET',
    },

    // 取消群发
    cancelSendMsg: {
        url: `${customerApi}/api/mass_sending/{id}/cancel`,
        type: 'POST',
    },

    // 计算过滤后的群发客户数量
    getFilterCustomerCount: {
        url: `${customerApi}/api/mass_sending/prepare`,
        type: 'POST',
    },
}
